module.exports = __webpack_public_path__ + "static/img/render1.ecfc4f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/render1.jpg
// module id = IMG1
// module chunks = 0